// ================================================= /
// ======   Accordion JS   ========================= /
// ================================================= /

/* global jQuery */

import gsap from 'gsap';

import animation from './animation';
import subnav from './subnav';

/**
 * Class for controlling accordion element
 */
class DispatchSkinAccordion {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-accordion';
		this.groupSelector = `${this.selector}-group`;
		this.groupAccordionSelector = `${this.groupSelector}__accordion`;
		this.contentSelector = `${this.selector}__content`;
		this.contentInnerSelector = `${this.selector}__content-inner`;
		this.toggleSelector = `${this.selector}__toggle`;
		this.toggleWasHoveredClass = 'was-hovered';
		this.startsOpenClass = 'starts-open';
		this.openClass = 'is-open';

		this.eventNamespace = 'dispatchSkinAccordion';
		this.toggleHoverAnimationDuration = 751;
		this.openAnimationDuration = 0.75;
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		if ( jQuery( this.selector ).length ) {

			this.events();
		}
	}

	/**
	 * Wires up events
	 */
	events() {

		this.eventDelegationParent = jQuery( '.site' );

		// Toggle click
		this.eventDelegationParent.on(
			`vclick.${this.eventNamespace}`,
			this.toggleSelector,
			this.handleToggleClick.bind( this )
		);

		animation.addHook(
			this.groupSelector,
			function( group ) {
				gsap.to( group.find( this.groupAccordionSelector ), { duration: 0.25, stagger: 0.1, opacity: 1, y: 0 } );
			}.bind( this )
		);
	}

	/**
	 * Handles the toggle click.
	 */
	handleToggleClick( event ) {

		const toggle = jQuery( event.target );
		const targetAccordion = toggle.closest( this.selector );

		const shouldOpen = ! targetAccordion.hasClass( this.openClass )
			&& ! targetAccordion.hasClass( this.startsOpenClass );

		this.toggle( targetAccordion, shouldOpen );

		const group = toggle.closest( this.groupSelector );

		if ( group.length ) {

			group.find( this.selector )
				.not( targetAccordion )
				.each(
					function( index, accordion ) {
						this.toggle( jQuery( accordion ), false );
					}.bind( this )
				);
		}
	}

	/**
	 * Toggles an accordion.
	 */
	toggle( accordion, shouldOpen = true ) {

		const isOpen = accordion.hasClass( this.openClass )
			|| accordion.hasClass( this.startsOpenClass );

		if ( isOpen === shouldOpen ) {
			return;
		}

		const content = accordion.find( this.contentSelector );
		const classMethod = shouldOpen ? 'addClass' : 'removeClass';

		accordion[classMethod]( this.openClass )
			.parent( this.groupAccordionSelector )[
				classMethod]( this.openClass );

		if ( accordion.hasClass( this.startsOpenClass ) ) {
			accordion.removeClass( this.startsOpenClass );
			gsap.set( content, { height: 'auto' } );
		}

		if ( shouldOpen ) {
			animation.stagger( accordion.closestDescendant( animation.selector, true ), 0 );
		}

		gsap.to(
			content,
			{
				duration: this.openAnimationDuration,
				height: shouldOpen ? 'auto' : 0,
				onComplete: () => subnav.reset()
			}
		);
	}

}

const accordion = new DispatchSkinAccordion();
export default accordion;



// WEBPACK FOOTER //
// ./src/js/inc/accordion.js